// router
import { useSearchParams } from 'react-router-dom';

// react
import { useContext } from 'react';

// mui
import { Grid } from '@mui/material';

// context
import { ContextLoans } from '../Project.context';

// pages
import { Details } from './Details/Details';

// dialogs
import { DialogAddFinancingSource } from '../../../dialogs/DialogAddFinancingSource/DialogAddFinancingSource';
import { DialogEditFinancingSource } from '../../../dialogs/DialogEditFinancingSource/DialogEditFinancingSource';

export const Financing = () => {
	// state
	const [searchParams, setSearchParams] = useSearchParams();

	// context
	const { refetchLoans } = useContext(ContextLoans);

	// vars
	const paramDialog = searchParams.get('dialog');

	// handlers
	const handleCloseDialog = () => {
		setSearchParams((params) => {
			params.delete('dialog');
			params.delete('dialogLoan');
			return params;
		});
	};

	return (
		<>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Details />
				</Grid>
			</Grid>
			<DialogAddFinancingSource
				isOpen={paramDialog === 'addFinancingSource'}
				onClose={handleCloseDialog}
				onSuccess={() => {
					refetchLoans();
				}}
			/>
			<DialogEditFinancingSource
				isOpen={paramDialog === 'editFinancingSource'}
				onClose={handleCloseDialog}
				onSuccess={() => {
					refetchLoans();
				}}
			/>
		</>
	);
};
